import FormControl from "@mui/material/FormControl";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

export const handleAddNewRow = (
  row: any,
  setRows: (callback: (prevRows: any[]) => any[]) => void
) => {
  const newRow = { ...row, id: new Date().getTime(), isNew: true };

  setRows((prevRows: any[]) => {
    const rowIndex = prevRows.findIndex((r) => r.id === row.id);

    if (rowIndex === -1) return prevRows;
    const updatedRows = [
      ...prevRows.slice(0, rowIndex + 1),
      newRow,
      ...prevRows.slice(rowIndex + 1),
    ];

    return updatedRows;
  });
};

// export const handleClickOpenDeleteModal = () => {};

export const AddOrDeleteColumn = (
  params: any,
  props: any,
  isEditEnabled: boolean,
  handleClickOpenDeleteModal: (row: any) => void,
  handleAddNewRow: (row: any, setRows: any) => void
) => {
  return (
    <>
      <FormControl sx={{ m: 1, width: 165 }}>
        <div className="action-btn">
          {isEditEnabled ? (
            <span
              title="Delete Row"
              onClick={() => handleClickOpenDeleteModal(params.row)}
            >
              <DeleteIcon className="delete-contrain" />
            </span>
          ) : (
            <DeleteIcon
              className="delete-contrain"
              style={{ color: "#ccc", cursor: "not-allowed" }}
            />
          )}
          {isEditEnabled ? (
            <span
              title="Add Row"
              onClick={() => handleAddNewRow(params.row, props.setRows)}
            >
              <AddIcon className="delete-contrain" />
            </span>
          ) : (
            <AddIcon
              className="delete-contrain"
              style={{ color: "#ccc", cursor: "not-allowed" }}
            />
          )}
        </div>
      </FormControl>
    </>
  );
};

export const processingRowUpdate = (
  newRow: any,
  getEditedTableData: any,
  setEditedTableData: any
) => {
  const updatedRow = { ...newRow };

  // Check if this row already exists in editedTableData
  const existingRowIndex = getEditedTableData.findIndex(
    (row: any) => row.id === updatedRow.id
  );

  if (existingRowIndex !== -1) {
    // Update existing row instead of adding duplicate
    const updatedEditedData = [...getEditedTableData];
    updatedEditedData[existingRowIndex] = updatedRow;
    setEditedTableData(updatedEditedData);
  } else {
    // Add new row only if it doesn't exist
    setEditedTableData((prev: any[]) => [...prev, updatedRow]);
  }

  console.log(updatedRow, "updatedRow");
  return updatedRow;
};
